import fpFreeModule from '@fingerprintjs/fingerprintjs'
import fpProModule from '@fingerprintjs/fingerprintjs-pro'

import { getCookie, setCookie } from '../helpers/cookies'
import { getRootDomain } from '../helpers/getRootDomain'

export const DEVICE_ID_COOKIE_NAME = 'fp_device_id'

const cookieExpireDate = new Date()

cookieExpireDate.setFullYear(cookieExpireDate.getFullYear() + 5)

export const getDeviceId = async (apiKey: string | undefined = '') => {
  const fingerprint = getCookie(DEVICE_ID_COOKIE_NAME)

  if (fingerprint) {
    return fingerprint
  }

  try {
    const fpPro = await fpProModule.load({ apiKey })
    const { visitorId: visitorIdPro } = await fpPro.get()

    setCookie(DEVICE_ID_COOKIE_NAME, visitorIdPro, { domain: getRootDomain(), expires: cookieExpireDate, path: '/' })

    return visitorIdPro
  } catch {
    const fpFree = await fpFreeModule.load()

    const { visitorId } = await fpFree.get()

    const visitorIdFree = `fallback_${visitorId}`

    setCookie(DEVICE_ID_COOKIE_NAME, visitorIdFree, { domain: getRootDomain(), expires: cookieExpireDate, path: '/' })

    return visitorIdFree
  }
}
